/**
 * Created by Bartosz.Pietrzyk on 2016-03-16.
 *            Olga Szczepaniak
 *            Dominika Grabowska
 */
'use strict';
import { __extends } from "tslib";
//import noUiSlider moved to bss-package-toolbox, with some padding modifications
import sliderTemplate from '../template/slider.hbs';
// Template containing input and blocked slider, to handle big values of slider steps
import inputTemplate from '../template/slider--input.hbs';
import incrementerTemplate from '../template/incrementer.hbs';
import sliderLabelWithInputTemplate from '../template/slider--label-with-input.hbs';
import BSSAbstractComponent from '../../bss-abstract-component/js/bss-abstract-component.js';
import BSSInfoHintComponent from '../../bss-infohint-component/js/bss-infohint-component.js';
import helper from '@main/externals/bss-package-helper/js/helper';
import logger from '@main/externals/bss-package-logger/js/logger';
import numbro from '../../../../../main-dxp/externals/numbro/js/numbro';
import _, { parseInt } from 'lodash';
function filter() {
    return false;
}
var sliderTemplates = {
    defaultTemplate: sliderTemplate,
    labelWithInputTemplate: sliderLabelWithInputTemplate,
    incrementerTemplate: incrementerTemplate,
    inputTemplate: inputTemplate,
};
/**
 * BSSSliderComponent class
 */
var BSSSliderComponent = /** @class */ (function (_super) {
    __extends(BSSSliderComponent, _super);
    /**
     * @desc BSSSliderComponent constructor - generates all necessary objects and initialize slider
     * @param {Object} [_entityTemplate=null] - simulator template
     * @param {String} [containerSelector=null] - component container selector
     * @param {Object} [config=null] - configuration of comonent
     * @param {EventManager} [eventManager=null] - instance of EventManager
     * @param {Formatter} [formatter=null] - instance of Formatter
     * @param {Resolution} [resolution=null] - device Resolution
     * @param {Object} [toolbox=null] - provides common libraries: jquery and lodash
     */
    function BSSSliderComponent(_entityTemplate, containerSelector, config, eventManager, formatter, resolution, toolbox) {
        if (_entityTemplate === void 0) { _entityTemplate = null; }
        if (containerSelector === void 0) { containerSelector = null; }
        if (config === void 0) { config = null; }
        if (eventManager === void 0) { eventManager = null; }
        if (formatter === void 0) { formatter = null; }
        if (resolution === void 0) { resolution = null; }
        if (toolbox === void 0) { toolbox = null; }
        var _this = _super.call(this, _entityTemplate, containerSelector, config, eventManager, formatter, resolution, sliderTemplates, toolbox) || this;
        logger.info('SliderComponent:  => constructor : componentId: ' +
            config.componentId +
            ' | Params: ', _entityTemplate, containerSelector, config, eventManager, formatter, resolution, sliderTemplates, logger, toolbox);
        _this._actualModelList = config.modelsList;
        _this._actualMonthlyPayment = config.monthlyPayment;
        _this._initial_config = _.cloneDeep(config);
        _this._initial_config.modelsList = _.cloneDeep(_this._actualModelList);
        _this._initial_config.monthlyPayment = _.cloneDeep(_this._actualMonthlyPayment);
        if (containerSelector === null) {
            _this.setErrorObject({
                errorMsg: 'Error: parameter: containerSelector is necessary!',
                errorSeverity: 'critical',
            });
        }
        /**
         * @type {Boolean}
         * @public
         */
        if (_this.isNotRendered) {
            return _this;
        }
        /**
         * @desc stores component name and version @@name and @@version is replaced in build task with data from package.json
         * @type {String}
         */
        _this._componentVersion = '@@name ver. @@version';
        /**
         * @desc prevent trigger update function on slider.
         * @type {Boolean}
         */
        _this.preventUpdateEvent = false;
        /**
         * @desc flag - informs if slider is fully initialized
         * @type {Boolean}
         * @private
         */
        _this._isSliderInitialized = false;
        /**
         * @desc product iterator
         * @type {number}
         */
        _this.productIterator = 0;
        /**
         * @type {null}
         * @private
         */
        _this._slider = null;
        /**
         * @desc this flag that checks if you can send another request
         * @type {boolean}
         */
        _this._isOnSendRequest = true;
        /**
         * @type {boolean}
         * @private
         * @desc describe that simulator is in popup
         */
        _this._isInPopup = _this._entityTemplate.attr('is-popup')
            ? !!_this._entityTemplate.attr('is-popup')
            : false;
        var classNameBodyContainer = _this._entityTemplate.attr('data-name-body');
        var bodyContainer;
        if (classNameBodyContainer) {
            bodyContainer = _this._componentScope.closest(_this._toolbox.$(classNameBodyContainer));
        }
        /**
         * @type {jQuery|HTMLElement}
         * @private
         * @desc global window element
         */
        _this._globalWindow = _this._isInPopup
            ? _this._toolbox.$(bodyContainer)
            : _this._window;
        var inputs = _this._componentTemplate.find('input');
        /**
         * @desc inputs type text
         * @type {jQuery|HTMLElement}
         * @private
         */
        _this._textInput = inputs.filter('[type="text"]');
        _this._textInput.on('change.' + _this._config.componentId, _this._closePopup.bind(_this), _this._setValueFormInput.bind(_this));
        _this._textInput.on('keypress.' + _this._config.componentId, _this._onEnter.bind(_this));
        _this._textInput.on('keydown.' + _this._config.componentId, _this._onCharactersEnter.bind(_this));
        if (_this._config.selectInput) {
            var self_1 = _this;
            _this._textInput.on('click.' + _this._config.componentId, function () {
                if (self_1._entityTemplate.hasClass('iPhone') ||
                    self_1._entityTemplate.hasClass('iPad')) {
                    this.setSelectionRange(0, self_1._config.inputMaxLength);
                }
                else {
                    this.select();
                }
            });
        }
        _this._inputOverlayHandler = _this._inputOverlay.bind(_this);
        _this._textInput.on('keyup.' + _this._config.componentId, _this._setInputOverlay.bind(_this));
        _this._textInput.on('focusout.' + _this._config.componentId, function () {
            var tempFormatter = _this._config.variableAdditional &&
                typeof _this._formatterAdditional !== 'undefined'
                ? _this._formatterAdditional
                : _this._config.formatter;
            var mark = _this._formatter.formatters[tempFormatter + 'Settings'].mark;
            var thousand = _this._formatter.formatters[tempFormatter + 'Settings'].thousand;
            var actualValue = _this._textInput
                .val()
                .replace(thousand, '')
                .replace(mark, '.')
                .replace(/[^0-9.]+/g, '');
            _this._textInput.val(_this._formatter.getFormattedValue(actualValue, tempFormatter));
            _this._activeElement = null;
        });
        /**
         * @desc inputs type number
         * @type {jQuery|HTMLElement}
         * @private
         */
        _this._numberInput = inputs.filter('[type="number"]');
        _this._numberInput.on('change.' + _this._config.componentId, _this._closePopup.bind(_this), _this._setValueFormInput.bind(_this));
        _this._numberInput.on('input.' + _this._config.componentId, _this._setMaxLengthFormInput.bind(_this));
        if (_this._config.popupInputResolutions) {
            _this._inputPopup = _this._componentTemplate.find('#' + _this._config.componentId + '_popup');
            _this._inputPopup.appendTo(_this._entityTemplate); //Move popup content to end of entity.(Problem with position fix.)
        }
        /**
         * @desc contains reference to slider value indicator
         * @type {Object}
         * @private
         */
        _this._valueIndicator = _this._componentTemplate.find('#' + _this._config.componentId + '_indicator');
        _this._prepareData();
        _this._initSlider(_this._config);
        _this._initSliderBtns();
        _this._preparePaddings();
        var configHint = {
            hintText: _this._config.hintText,
            updateSubscriptionOff: true,
            productId: _this._config.productId,
            texts: _this._config.texts,
            resultData: _this._config.resultData,
            componentId: _this._config.componentId,
            isLocaleAphelia: _this._config.isLocaleAphelia,
        };
        if (_this._config.hintText || _this._config.hintTitle) {
            _this._infohint = new BSSInfoHintComponent(_entityTemplate, '.' + _this._config.componentId + '_info-hint-container', configHint, eventManager, formatter, resolution, toolbox);
        }
        if (_this._config.isInPopup) {
            var filterName = _this._config.filterName;
            _this._entityTemplate
                .find(_this._toolbox.$("#".concat(_this._config.filterName, "_remove")))
                .on('click.' + _this._config.componentId, _this._setDefaultValue.bind(_this, filterName));
        }
        return _this;
    }
    Object.defineProperty(BSSSliderComponent.prototype, "outputValueObj", {
        /**
         * @desc getter for this._outputValueObj
         * @return {Object} description
         */
        get: function () {
            return this._outputValueObj;
        },
        enumerable: false,
        configurable: true
    });
    BSSSliderComponent.prototype._setDefaultValue = function (filterName) {
        var productId = this._config.productId[0];
        if (this._config.filterName === filterName) {
            this._onValueChange(this._initial_config.resultData[productId][filterName], null);
            document.getElementById(this._config.buttonToUpdate).textContent =
                this._config.buttonText;
        }
    };
    /**
     * @desc prepare padding in slider with range
     * @param {Boolean} reinit is slider reinited or first inited
     * @private
     */
    BSSSliderComponent.prototype._preparePaddings = function (reinit) {
        if (reinit === void 0) { reinit = false; }
        logger.info('SliderComponent: ' +
            this._config.componentId +
            ' => function : _preparePaddings | Params: ', reinit);
        if (this._config.padding) {
            if (!reinit) {
                this._componentScope.append('<span class="bss-slider_color-picker"><span class="bss-slider_color-picker-range"></span><span class="bss-slider_color-picker-padding"></span></span>');
                this._paddingColor = this._componentScope
                    .find('.bss-slider_color-picker-padding')
                    .css('color');
                this._rangeColor = this._componentScope
                    .find('.bss-slider_color-picker-range')
                    .css('color');
            }
            var gradientString = 'linear-gradient(to right, ' +
                this._paddingColor +
                ' ' +
                ((this._config.limitLeft - this._config.range.min) /
                    (this._config.range.max - this._config.range.min)) *
                    100 +
                '%,' +
                this._rangeColor +
                ' ' +
                ((this._config.limitLeft - this._config.range.min) /
                    (this._config.range.max - this._config.range.min)) *
                    100 +
                '%,' +
                this._rangeColor +
                ' ' +
                ((this._config.limitRight - this._config.range.min) /
                    (this._config.range.max - this._config.range.min)) *
                    100 +
                '%,' +
                this._paddingColor +
                ' ' +
                ((this._config.limitRight - this._config.range.min) /
                    (this._config.range.max - this._config.range.min)) *
                    100 +
                '%)';
            this._componentScope
                .find('.noUi-base')
                .css({ 'background-image': gradientString });
            this._componentScope
                .find('.noUi-origin')
                .css({ 'background-color': 'transparent' });
        }
    };
    /**
     * @desc disable input overlay
     * @param {Object} event object
     * @private
     */
    BSSSliderComponent.prototype._inputOverlay = function (event) {
        if (event) {
            event.preventDefault();
            this._$inputOverlay.off('click', this._inputOverlayHandler.bind(this));
            this._textInput.off('blur', this._inputOverlayHandler.bind(this));
            this._$inputOverlay.remove();
            this._overlaySet = false;
        }
    };
    /**
     * @desc set input overlay to simulate blur event by click
     * @private
     */
    BSSSliderComponent.prototype._setInputOverlay = function () {
        if (!this._overlaySet && this._resolution.getCurrent() !== 'xs') {
            var $body = this._toolbox.$('body');
            $body.append('<div id="bss-slider-input-overlay" style="position: absolute; ' +
                'top: 0; ' +
                'bottom: 0; ' +
                'left: 0; ' +
                'right: 0; ' +
                'z-index: 999999999;' +
                '"></div>');
            this._$inputOverlay = $body.find('#bss-slider-input-overlay');
            this._textInput.on('blur', this._inputOverlayHandler.bind(this));
            this._$inputOverlay.on('click', this._inputOverlayHandler.bind(this));
            $body.css('position', 'relative');
            this._overlaySet = true;
        }
    };
    /**
     * @desc _prepareData - merge default slider config with calculated config from proxy
     * @private
     * @override
     */
    BSSSliderComponent.prototype._prepareData = function () {
        logger.info('SliderComponent: ' +
            this._config.componentId +
            ' => function : _prepareData');
        /**
         * @type {boolean}
         * @private
         */
        this._isSliderDisabled = false;
        /**
         * @desc stores output data
         * @type {Object}
         */
        this._outputValueObj = {};
        this._outputValueName = '';
        /**
         * @desc store all possible slider values
         * @type {Array}
         */
        this._sliderValues = [];
        /**
         * @desc flag: set true when data provided to slider are from list
         * @type {Boolean}
         */
        this._isListUsed = null;
        if (typeof this._sliderLimitVariables) {
            /**
             * @desc variable describes current slider settings
             * @type {Object}
             * @property {Number} [variableMin=null]
             * @property {Number} [variableMax=null]
             * @property {Number} [variableStep=null]
             * @property {String} [variableList=null]
             * @property {Object} numericalObj
             */
            this._sliderLimitVariables = {
                variableMin: null,
                variableMax: null,
                variableStep: null,
                variableList: null,
                numericalObj: {},
            };
        }
        if (this._config.productId[0] === 'general') {
            this.productIterator = this._config.productId.length - 1;
        }
        else {
            this.productIterator = 0;
        }
        // step value should be cleared, sometimes we set step =1 this._config.range.min.toString() === this._config.start.toString() and
        // when we get list step isn't override
        delete this._config.step;
        var productId = this._config.productId[this.productIterator];
        this._config = this._generateCustomSliderConfig(this._config);
        this._config.resultData[productId][this._outputValueName + '_minValue'] =
            this._config.range.min[0] || this._config.range.min;
        this._config.resultData[productId][this._outputValueName + '_maxValue'] =
            this._config.range.max[0] || this._config.range.max;
        if (!(productId in this._toolbox.resultDataFlat)) {
            this._toolbox.resultDataFlat[productId] = {};
        }
        this._toolbox.resultDataFlat[productId][this._outputValueName + '_maxValue'] = this._config.resultData[productId][this._outputValueName + '_maxValue'];
        this._toolbox.resultDataFlat[productId][this._outputValueName + '_minValue'] = this._config.resultData[productId][this._outputValueName + '_minValue'];
        if (typeof this._config.formatter !== 'undefined') {
            this._config.minValue =
                '<value data-formatter="' +
                    this._config.formatter +
                    '" data-value="' +
                    productId +
                    '.' +
                    this._outputValueName +
                    '_minValue"></value>';
            this._config.maxValue =
                '<value data-formatter="' +
                    this._config.formatter +
                    '" data-value="' +
                    productId +
                    '.' +
                    this._outputValueName +
                    '_maxValue"></value>';
        }
        else {
            this._config.minValue =
                '<value data-value="' +
                    productId +
                    '.' +
                    this._outputValueName +
                    '_minValue"></value>';
            this._config.maxValue =
                '<value data-value="' +
                    productId +
                    '.' +
                    this._outputValueName +
                    '_maxValue"></value>';
        }
        if (this._config.minMaxFormatter) {
            this._config.minValue =
                '<value data-formatter="' +
                    this._config.minMaxFormatter +
                    '" data-value="' +
                    productId +
                    '.' +
                    this._outputValueName +
                    '_minValue"></value>';
            this._config.maxValue =
                '<value data-formatter="' +
                    this._config.minMaxFormatter +
                    '" data-value="' +
                    productId +
                    '.' +
                    this._outputValueName +
                    '_maxValue"></value>';
        }
        if (this._config.variableAdditional &&
            this._config.variableAdditionalMin &&
            this._config.variableAdditionalMax) {
            this._valueAdditionalMin = parseFloat(this._getValue(this._config.variableAdditionalMin));
            this._valueAdditionalMax = parseFloat(this._getValue(this._config.variableAdditionalMax));
        }
        this._updateOutputValueObj(this._config.start);
        this._prepareLimitObj(this._sliderLimitVariables);
        if (typeof this._config.start === 'undefined' ||
            this._config.start === '') {
            try {
                this.setErrorObject({
                    errorMsg: 'Config -> slider default value is not defined',
                    errorSeverity: 'critical',
                });
            }
            catch (errorMsg) {
                this.setErrorObject({
                    errorMsg: errorMsg,
                    errorSeverity: 'critical',
                });
            }
            this.isNotRendered = true;
        }
        else if (this._config.range.min.toString() === this._config.range.max.toString()) {
            if (this._config.range.min.toString() === this._config.start.toString()) {
                this._config.range.min--;
                this._config.range.max++;
                this._config.step = 1;
                this._isSliderDisabled = true;
            }
            else {
                this.setErrorObject({
                    errorMsg: 'Config -> default value is out of slider range',
                    errorSeverity: 'critical',
                });
            }
        }
        else if (parseFloat(this._config.range.min) > parseFloat(this._config.range.max)) {
            try {
                this.setErrorObject({
                    errorMsg: 'ERROR: Slider Component -> min value is greater than max value',
                    errorSeverity: 'critical',
                });
            }
            catch (errorMsg) {
                this.setErrorObject({
                    errorMsg: errorMsg,
                    errorSeverity: 'critical',
                });
                this.isNotRendered = true;
            }
        }
        else if (Math.abs(parseFloat(this._config.range.max) - parseFloat(this._config.range.min)) < parseFloat(this._config.step)) {
            try {
                this.setErrorObject({
                    errorMsg: 'Config -> step is greater than max value',
                    errorSeverity: 'critical',
                });
            }
            catch (errorMsg) {
                this.setErrorObject({
                    errorMsg: errorMsg,
                    errorSeverity: 'critical',
                });
                this._config.step = 0.01;
                this._isSliderDisabled = true;
            }
        }
    };
    /**
     * @desc refresh the optional value indicator
     * @param {String} value
     * @private
     */
    BSSSliderComponent.prototype._refreshIndicator = function (value) {
        logger.info('SliderComponent: ' +
            this._config.componentId +
            ' => function : _refreshIndicator' +
            ' | Params: ', value);
        var localValue = value;
        if (this._valueIndicator.length > 0) {
            if (typeof localValue === 'undefined') {
                localValue = this._slider.get();
            }
            this._valueIndicator.html(localValue);
        }
    };
    /**
     * @desc _sliderReinit reinits the slider component
     * @private
     */
    BSSSliderComponent.prototype._sliderReinit = function () {
        var _this = this;
        logger.info('SliderComponent: ' +
            this._config.componentId +
            ' => function : _sliderReinit');
        this._isSliderInitialized = false;
        var variable = this._config.variable.substr(this._config.variable.indexOf('.') + 1, this._config.variable.lastIndexOf("'") -
            2 -
            this._config.variable.indexOf('.') +
            1);
        var isInNewLimits = false;
        var actualVariable = this._config.resultData[this._config.productId[0]][variable];
        this._prepareData();
        this._preparePaddings(true);
        if (this._errorType) {
            return;
        }
        this._config.ariaFormat = {
            to: function (value) {
                var _a = _this._config.range, min = _a.min, max = _a.max;
                var percentage = ((value - min) / (max - min)) * 100;
                return "".concat(percentage.toFixed(2));
            },
            from: function (value) {
                var _a = _this._config.range, min = _a.min, max = _a.max;
                var percentage = parseFloat(value);
                return (percentage / 100) * (max - min) + min;
            },
        };
        var _a = this._config, format = _a.format, formatter = _a.formatter;
        this._config.format = {
            to: function (value) { return numbro.formatUniversal(value, format, formatter); },
            from: function (value) { return Number(value); },
        };
        this._slider.updateOptions(this._config);
        /* Slider issue - there is initialization issue,
                 when we use float values and formatter in js decimal values are separated by a dot and
                 when we use formatter which have dot as a thousand slider removes dot
                 eg. comes '21.2' and slider treats it after unformatting as 212
                 slider expects that initial data comes formatted but we pass unformatted data */
        if (typeof this._config.start === 'object') {
            if (parseFloat(actualVariable[1]) <= this._config.range.max &&
                parseFloat(actualVariable[0]) >= this._config.range.min) {
                isInNewLimits = true;
            }
        }
        else {
            if (parseFloat(actualVariable) <= this._config.range.max &&
                parseFloat(actualVariable) >= this._config.range.min) {
                isInNewLimits = true;
            }
        }
        var closestNumber;
        var closestNumber2;
        if (typeof this._config.start === 'object') {
            closestNumber = this._getClosestNumber(this._config.start[0], this._sliderValues);
            closestNumber2 = this._getClosestNumber(this._config.start[1], this._sliderValues);
            this._setComponentsValue([closestNumber, closestNumber2], 'update');
            //this._setComponentsValue(closestNumber2, 'update');
        }
        else {
            closestNumber = this._getClosestNumber(this._config.start, this._sliderValues);
            this._setComponentsValue(closestNumber, 'update');
        }
        if (isInNewLimits) {
            this._config.start = actualVariable;
        }
        else {
            this._setComponentsValue(closestNumber, 'update');
        }
        this._reinitPips();
        if (this._textInput) {
            this._setValueFromSlider('init');
        }
        if (this._config.variableAdditional) {
            this._setValueOnInputVariableAdditional();
        }
        this._isSliderInitialized = true;
        if (typeof this._config.start === 'object') {
            if (parseFloat(this._config.start[0]) !== closestNumber ||
                parseFloat(this._config.start[1]) !== closestNumber2) {
                this._updateCorrectValue([closestNumber, closestNumber2]);
            }
        }
        else {
            if (parseFloat(this._config.start) !== closestNumber) {
                this._updateCorrectValue(closestNumber);
            }
        }
    };
    /**
     * @desc _updateOutputValueObj - updates output object with current value
     * @param {String} value
     * @private
     */
    BSSSliderComponent.prototype._updateOutputValueObj = function (value) {
        logger.info('SliderComponent: ' +
            this._config.componentId +
            ' => function : _updateOutputValueObj' +
            ' | Params: ', value);
        this._outputValueObj = {};
        if (this._isOnlyValueAdditionalChange) {
            this._outputValueObj[this._outputValueAdditional] = value;
        }
        else {
            this._outputValueObj[this._outputValueName] = value;
        }
    };
    /**
     * @desc _initSlider - initialize slider
     * @param {Object} sliderConfig - slider configuration object
     * @private
     */
    BSSSliderComponent.prototype._initSlider = function (sliderConfig) {
        var _a, _b;
        logger.info('SliderComponent: ' +
            this._config.componentId +
            ' => function : _initSlider | Params: ', sliderConfig);
        if (this.isDestroyed) {
            return;
        }
        sliderConfig.ariaFormat = {
            to: function (value) {
                var _a = sliderConfig.range, min = _a.min, max = _a.max;
                var percentage = ((value - min) / (max - min)) * 100;
                return "".concat(percentage.toFixed(2));
            },
            from: function (value) {
                var _a = sliderConfig.range, min = _a.min, max = _a.max;
                var percentage = parseFloat(value);
                return (percentage / 100) * (max - min) + min;
            },
        };
        var format = sliderConfig.format, formatter = sliderConfig.formatter;
        sliderConfig.format = {
            to: function (value) { return numbro.formatUniversal(value, format, formatter); },
            from: function (value) { return Number(value); },
        };
        if (this._config.forceRounded && sliderConfig.range.min > 0) {
            sliderConfig.range['1%'] =
                Math.ceil(sliderConfig.range.min / sliderConfig.step) *
                    sliderConfig.step;
            this._slider = this._toolbox.noUiSlider.create(this._componentScope.find('#' + this._config.componentId + '_slider')[0], sliderConfig);
        }
        else {
            this._slider = this._toolbox.noUiSlider.create(this._componentScope.find('#' + this._config.componentId + '_slider')[0], sliderConfig);
        }
        /* Slider issue - there is initialization issue,
                 when we use float values and formatter in js decimal values are separated by a dot and
                 when we use formatter which have dot as a thousand slider removes dot
                 eg. comes '21.2' and slider treats it after unformatting as 212
                 slider expects that initial data comes formatted but we pass unformatted data */
        var closestNumber;
        var closestNumber2;
        if (typeof this._config.start === 'object') {
            closestNumber = this._getClosestNumber(this._config.start[0], this._sliderValues);
            closestNumber2 = this._getClosestNumber(this._config.start[1], this._sliderValues);
            this._setComponentsValue([closestNumber, closestNumber2], 'update');
            //this._setComponentsValue(closestNumber2, 'update');
        }
        else {
            closestNumber = this._getClosestNumber(this._config.start, this._sliderValues);
            if ((_a = this._config.sliderHandle) === null || _a === void 0 ? void 0 : _a.sliderStartingValue) {
                closestNumber =
                    this._config.resultData[this.getProductId()][(_b = this._config.sliderHandle) === null || _b === void 0 ? void 0 : _b.sliderStartingValue];
            }
            this._setComponentsValue(closestNumber, 'update');
        }
        var $sliderTarget = this._componentScope.find(this._slider.target);
        this._$sliderBase = $sliderTarget.find('.noUi-base');
        this._sliderSteps = $sliderTarget.find('.noUi-marker');
        this._initializeSliderHandle();
        for (var i = 0, length_1 = this._sliderSteps.length; i < length_1; i++) {
            this._toolbox.$(this._sliderSteps[i]).text(this._sliderValues[i]);
        }
        this._dot = this._componentScope.find('.noUi-marker');
        this._slider.on('start', this._preventUpdateEvent.bind(this));
        this._slider.on('end', this._setValueFromSlider.bind(this, 'end'));
        this._slider.on('update', this._setValueFromSlider.bind(this, 'update'));
        if (this._config.variableAdditional) {
            this._setValueOnInputVariableAdditional();
        }
        if (this._isSliderDisabled === true || this._config.disabled) {
            this._slider.target.setAttribute('disabled', true);
        }
        this._initializeTaggingSlider();
        this._initializeSliderSeats();
        this._isSliderInitialized = true;
        if (!this._config.notDisabledPips) {
            this._movePips();
        }
        if (typeof this._config.start === 'object') {
            if (this._config.start[0] !== closestNumber ||
                this._config.start[1] !== closestNumber2) {
                this._updateCorrectValue([closestNumber, closestNumber2]);
            }
        }
        else {
            if (this._config.start !== closestNumber) {
                this._updateCorrectValue(closestNumber);
            }
        }
    };
    /**
     * @desc check if slider limits changed modifies updateObject(data) and fires super method
     * @param {String} publisherName - event owner name
     * @param {Object} data - updateObject holds new text and dataResult
     * @emits {bss-component-data-rebound-$COMPONENT-ID'}
     * @private
     */
    BSSSliderComponent.prototype.update = function (publisherName, data) {
        var _a;
        logger.info('SliderComponent: ' +
            this._config.componentId +
            ' => function : _update' +
            ' | Params: ', publisherName, data);
        // save update timestap - for component-critical-error handling
        this._lastUpdateTimestamp = data.updateTimestamp;
        // if there is regular update event (not revert state) and critical error was thrown, do not update this component!
        if (this._stopUpdateFlag && !this._isRevertStateEvent) {
            this._stopUpdateFlag = false;
            if (typeof data.resultData[this._config.productId[0]].error_code !==
                'undefined') {
                this.setErrorObject({
                    errorMsg: 'config -> there is no complete set of data',
                    errorSeverity: 'critical',
                });
                this._onCriticalError(this._errorObj);
            }
            return;
        }
        this.preventUpdateEvent = true;
        if (this._config.productId[0] === 'general') {
            this.productIterator = this._config.productId.length - 1;
        }
        else {
            this.productIterator = 0;
        }
        var productId = this._config.productId[this.productIterator];
        this._resetErrorObject();
        if (this._isSliderLimitChanged(data.resultData[productId], this._sliderLimitVariables) &&
            !this._forceUsingRange(this._config)) {
            this._config.resultData[productId] = data.resultData[productId];
            this._sliderReinit(data.resultData[productId]);
            data.resultData[productId][this._outputValueName + '_minValue'] =
                this._config.resultData[productId][this._outputValueName + '_minValue'];
            data.resultData[productId][this._outputValueName + '_maxValue'] =
                this._config.resultData[productId][this._outputValueName + '_maxValue'];
            this._isCanceledTaggingEvent = false;
        }
        else if (typeof data.resultData[productId][this._outputValueName] !== 'undefined') {
            var valueToUpdate = this._forceUsingRange(this._config)
                ? data.resultData[productId][this._outputValueName][1]
                : data.resultData[productId][this._outputValueName];
            this._setComponentsValue(valueToUpdate, 'update');
            if (typeof data.resultData[productId][this._outputValueAdditional] !==
                'undefined') {
                this._setValueOnInputVariableAdditional(data.resultData[productId][this._outputValueAdditional]);
            }
            data.resultData[productId][this._outputValueName + '_minValue'] =
                this._config.resultData[productId][this._outputValueName + '_minValue'];
            data.resultData[productId][this._outputValueName + '_maxValue'] =
                this._config.resultData[productId][this._outputValueName + '_maxValue'];
        }
        this._toolbox.resultDataFlat[productId][this._outputValueName + '_maxValue'] = data.resultData[productId][this._outputValueName + '_maxValue'];
        this._toolbox.resultDataFlat[productId][this._outputValueName + '_minValue'] = data.resultData[productId][this._outputValueName + '_minValue'];
        this._validateDataOnChange(data, true);
        if (this._tagEventOnThrow !== null) {
            this._throwTaggingEvent(this._tagEventOnThrow, true);
            this._tagEventOnThrow = null;
        }
        this.preventUpdateEvent = false;
        this._eventManager.publish('bss-component-data-rebound-' + this._config.componentId, this._config.componentType + '-' + this._config.componentId, data);
        if (((_a = this._toolbox.$('#buttonFilter_duration_popup')) === null || _a === void 0 ? void 0 : _a.hasClass('is-active')) &&
            this._config.updateAnotherSlider) {
            this._updateMonthlyPaymentAccordingToDurationChange();
        }
        if (this._config.componentTemplate === 'incrementerTemplate') {
            this._toggleIncrementer();
        }
        this._actualModelList = data.resultData[productId].modelsList;
        this._stopUpdateFlag = false;
        this._isRevertStateEvent = false;
    };
    /**
     * @desc _updateMonthlyPaymentAccordingToDurationChange -
     * update monthly payment button when duration slider value change
     * @private
     */
    BSSSliderComponent.prototype._updateMonthlyPaymentAccordingToDurationChange = function () {
        logger.info('SliderComponent: ' +
            this._config.componentId +
            ' => function : _updateMonthlyPaymentAccordingToDurationChange');
        var productId = this._config.productId[0];
        var valueFromResult = this._entityTemplate
            .find(this._toolbox.$("#multivalueMonthlyPayment_".concat(productId, "_multivalueSlider_indicator")))
            .text();
        this._entityTemplate
            .find(this._toolbox.$("#buttonFilter_MonthlyPayment_".concat(productId, "_btn")))
            .text("".concat(this._config.between, " ").concat(valueFromResult));
    };
    /**
     * @desc _setNextValue - sets next possible value to slider and mobile input
     * @private
     */
    BSSSliderComponent.prototype._setNextValue = function () {
        logger.info('SliderComponent: ' +
            this._config.componentId +
            ' => function : _setNextValue');
        var curValue = this._getNumberRepresentation(this._slider.get());
        if (this._isListUsed) {
            var value = this._getStepNumber(curValue, 1);
            this._setComponentsValue(value);
        }
        else {
            if (curValue + this._config.step <= this._config.range.max) {
                var value = Number(this._config.step) + Number(curValue);
                this._setComponentsValue(value);
            }
        }
    };
    /**
     * @desc _toggleIncrementer - disable +/- buttons when can't be clicked
     * @private
     */
    BSSSliderComponent.prototype._toggleIncrementer = function () {
        logger.info('SliderComponent: ' +
            this._config.componentId +
            ' => function : _toggleIncrementer');
        var value = parseInt(this._getNumberRepresentation(this._slider.get()));
        var incrementer = this._componentTemplate.find('#' + this._config.componentId + '_plus');
        var decrementer = this._componentTemplate.find('#' + this._config.componentId + '_minus');
        incrementer.removeClass('disabled');
        decrementer.removeClass('disabled');
        if (value === this._config.minSeats) {
            decrementer.addClass('disabled');
        }
        else if (value === this._config.range.max) {
            incrementer.addClass('disabled');
        }
    };
    /**
     * @desc _setPrevValue - sets prev possible value to slider and mobile input
     * @private
     */
    BSSSliderComponent.prototype._setPrevValue = function () {
        logger.info('SliderComponent: ' +
            this._config.componentId +
            ' => function : _setPrevValue');
        var curValue = this._getNumberRepresentation(this._slider.get());
        if (this._isListUsed) {
            var value = this._getStepNumber(curValue, -1);
            this._setComponentsValue(value);
        }
        else {
            if (curValue - this._config.step >= this._config.minSeats) {
                var value = curValue - this._config.step;
                this._setComponentsValue(value);
            }
        }
    };
    /**
     * @desc _setComponentsValue - sets given value to both elements (slider and input)
     * @param {String} or {Array} value - value pushed to slider
     * @param {String} ev - event example as 'update'
     * @private
     */
    BSSSliderComponent.prototype._setComponentsValue = function (value, ev) {
        var _this = this;
        var _a;
        logger.info('SliderComponent: ' +
            this._config.componentId +
            ' => function : _setComponentsValue' +
            ' | Params: ', value, ev);
        if (typeof value !== 'undefined') {
            var val = void 0;
            var val2 = void 0;
            if (typeof value === 'object') {
                val = this._getFormattedRepresentation(value[0]);
                val2 = this._getFormattedRepresentation(value[1]);
            }
            else {
                val = this._getFormattedRepresentation(value);
                //only when there is a variableAdditional in the config
                if (this._config.variableAdditional) {
                    this._setValueOnInputVariableAdditional();
                }
                else {
                    this._setValueOnInput(val, value);
                }
            }
            if (typeof value === 'object') {
                if (this._getNumberRepresentation(this._slider.get()) !==
                    parseFloat(value)) {
                    this._slider.set([val, val2]);
                    this._componentScope
                        .find('.noUi-origin')
                        .css({ top: '0', transform: 'none' });
                    //order is important!!
                    this._isCanceledTaggingEvent = false;
                    this._onValueChange(value, ev);
                }
                else if (this._getNumberRepresentation(this._slider.get()[1]) !==
                    parseFloat(value)) {
                    this._slider.set([val, val2]);
                    //order is important!!
                    this._isCanceledTaggingEvent = false;
                    this._onValueChange(value, ev);
                }
                else {
                    this._isCanceledTaggingEvent = false;
                }
            }
            else {
                //only when new value != prev value - set slider value and send event|request to server
                if (this._getNumberRepresentation(this._slider.get()) !==
                    parseFloat(value)) {
                    this._slider.set(value);
                    //order is important!!
                    this._isCanceledTaggingEvent = false;
                    this._onValueChange(value, ev);
                }
                else {
                    this._isCanceledTaggingEvent = false;
                }
            }
        }
        var outputValueObjForDownpayment = ((_a = this._outputValueObj) === null || _a === void 0 ? void 0 : _a.downpayment) || null;
        if (outputValueObjForDownpayment &&
            value &&
            parseFloat(outputValueObjForDownpayment) !== parseFloat(value)) {
            var updateValue = function () {
                var val = _this._getFormattedRepresentation(value);
                _this._slider.set(val);
                //order is important!!
                _this._isCanceledTaggingEvent = false;
            };
            this._eventManager.subscribe("bss-data-change-ready-".concat(this._config.entityInstanceId), updateValue, 'SliderComponent');
        }
    };
    /**
     * @desc _checkValueAdditional - check if value is within limits
     * @param {String} value - variable
     * @private
     */
    BSSSliderComponent.prototype._checkValueAdditional = function (value) {
        logger.info('SliderComponent: ' +
            this._config.componentId +
            ' => function : _checkValueAdditional | Params: ', value);
        if (value <= this._valueAdditionalMin) {
            value = this._valueAdditionalMin;
        }
        else if (value >= this._valueAdditionalMax) {
            value = this._valueAdditionalMax;
        }
        return value;
    };
    /**
     * @desc _setValueFormInput - sets value from mobile(xs) input to slider
     * @param {Event} ev - event triggered on form elements
     * @private
     */
    BSSSliderComponent.prototype._setValueFormInput = function (ev) {
        logger.info('SliderComponent: ' +
            this._config.componentId +
            ' => function : _setValueFormInput | Params: ', ev);
        var value = this._toolbox.$(ev.currentTarget).val(); //this._textInput.val(),
        var unformattedValue = value;
        var closestNumber;
        if (ev.currentTarget.type !== 'number') {
            unformattedValue = this._getNumberRepresentation(value);
        }
        if (this._config.variableAdditional) {
            if (typeof this._formatterAdditional !== 'undefined') {
                unformattedValue = this._formatter.getValue(value, this._formatterAdditional);
            }
            this._isOnlyValueAdditionalChange = true;
            unformattedValue = this._checkValueAdditional(unformattedValue);
            if (unformattedValue === this._outputValueObj[this._outputValueAdditional]) {
                this._isCanceledTaggingEvent = true;
            }
            this._setValueOnInputVariableAdditional(unformattedValue);
            this._onValueChange(unformattedValue, 'end');
        }
        else {
            closestNumber = this._getClosestNumber(unformattedValue, this._sliderValues);
            if (closestNumber === this._outputValueObj[this._outputValueName]) {
                this._isCanceledTaggingEvent = true;
            }
            this._setComponentsValue(closestNumber, 'update');
        }
        this._isOnlyValueAdditionalChange = false;
    };
    /**
     * @desc _setMaxLengthFormInput - set max length on input type=number
     * @param {Event} ev - event triggered on form elements
     * @private
     */
    BSSSliderComponent.prototype._setMaxLengthFormInput = function (ev) {
        logger.info('SliderComponent: ' +
            this._config.componentId +
            ' => function : _setMaxLengthFormInput | Params: ', ev);
        var input = this._toolbox.$(ev.currentTarget);
        var value = input.val();
        var valueLength = input.val().length;
        var maxLength = parseInt(this._config.inputMaxLength);
        if (valueLength >= maxLength) {
            input.val(value.slice(0, maxLength));
        }
    };
    /**
     * @desc _getFormattedRepresentation - format value using default variable formatter
     * @param {String} value - variable to format
     * @return {String} formatted value
     * @private
     */
    BSSSliderComponent.prototype._getFormattedRepresentation = function (value) {
        logger.info('SliderComponent: ' +
            this._config.componentId +
            ' => function : _getFormattedRepresentation' +
            ' | Params: ', value);
        if (typeof value !== 'number') {
            value = parseFloat(value);
        }
        if (typeof this._config.formatter !== 'undefined') {
            return this._formatter.getFormattedValue(value, this._config.formatter);
        }
        else {
            return value;
        }
    };
    /**
     * @desc _getNumberRepresentation - unformes formatted value
     * @param {String} value - formatted variable
     * @return {Number} unformatted value
     * @private
     */
    BSSSliderComponent.prototype._getNumberRepresentation = function (value) {
        logger.info('SliderComponent: ' +
            this._config.componentId +
            ' => function : _getNumberRepresentation' +
            ' | Params: ', value);
        if (typeof this._config.formatter !== 'undefined') {
            return this._formatter.getValue(value, this._config.formatter);
        }
        else {
            return value;
        }
    };
    /**
     * @desc _onValueChange - update output object
     * @param {String} value - new value of update object
     * @param {String} ev - event example as 'update'
     * @private
     */
    BSSSliderComponent.prototype._onValueChange = function (value, ev) {
        var _a;
        logger.info('SliderComponent: ' +
            this._config.componentId +
            ' => function : _onValueChange' +
            ' | Params: ', value, ev);
        if (!this._isOnSendRequest) {
            return;
        }
        if ((_a = this._sliderHandleConfig) === null || _a === void 0 ? void 0 : _a.showPriceCarValue) {
            this._updateOutputValueObj(parseInt(value).toString());
        }
        else {
            this._updateOutputValueObj(value);
        }
        if (ev !== 'update') {
            if (this._config.buttonToUpdate) {
                var valueFromSlider = document.getElementById("".concat(this._config.componentId, "_indicator")).textContent;
                var betweenLiteral = '';
                if (typeof value === 'object' && !this._forceUsingRange(this._config)) {
                    betweenLiteral = this._config.between;
                }
                document.getElementById("".concat(this._config.buttonToUpdate)).textContent = "".concat(betweenLiteral, " ").concat(valueFromSlider);
            }
            this._onOutputChange(this._outputValueObj);
        }
    };
    /**
     * @desc _updateCorrectValue - update output object when default value for slider is out of range or step
     * @param {String} value - correct value of update object
     * @emits {bss-component-changed-ENTITYINSTANCEID'}
     * @private
     */
    BSSSliderComponent.prototype._updateCorrectValue = function (value) {
        logger.info('SliderComponent: ' +
            this._config.componentId +
            ' => function : _updateCorrectValue' +
            ' | Params: ', value);
        this._updateOutputValueObj(value);
        var output = {};
        output[this._config.productId[0]] = this._outputValueObj;
        output[this._config.productId[0]].triggerName = Object.keys(this._outputValueObj)[0];
        this._eventManager.publish('bss-component-changed-' + this._config.entityInstanceId, this._config.componentType + '-' + this._config.componentId, output);
    };
    /**
     * @desc method update amount slider handle
     * @param {String} value
     * @private
     */
    BSSSliderComponent.prototype._updateAmountSliderHandle = function (value) {
        logger.info('SliderComponent: ' +
            this._config.componentId +
            ' => function : _updateAmountSliderHandle' +
            ' | Params: ', value);
        if (typeof this._sliderHandleConfig === 'object') {
            if (this._priceCar) {
                if (this._sliderHandleConfig.showPriceCarValue) {
                    var currentPrice = parseFloat((value / 100) * this._priceCar);
                    var priceWithFormatter = this._formatter.getFormattedValue(currentPrice, this._sliderHandleConfig.sliderHandleFormatter);
                    var showAdditionalSliderValue = !!this._sliderHandleConfig.showAdditionalSliderValue;
                    var additionalSliderValueFormatter = this._sliderHandleConfig
                        .sliderHandleAdditionalSliderValueFormatter || null;
                    if (showAdditionalSliderValue && additionalSliderValueFormatter) {
                        var additionalSliderValueWithFormatter = this._formatter.getFormattedValue(value, additionalSliderValueFormatter);
                        priceWithFormatter = "".concat(priceWithFormatter, " (").concat(additionalSliderValueWithFormatter, ")");
                    }
                    this._valueIndicator.html(priceWithFormatter);
                }
                else {
                    var currentValuePercentage = parseFloat((value / this._priceCar) * 100);
                    this._$sliderAmountHandle.html(currentValuePercentage.toFixed(this._sliderHandleDecimalPlaces) +
                        '%');
                }
            }
            else {
                if (typeof value === 'object') {
                    var value1 = void 0;
                    var value2 = void 0;
                    if (this._sliderHandleFormatter) {
                        value1 = this._formatter.getFormattedValue(value[0], this._sliderHandleFormatter);
                        value2 = this._formatter.getFormattedValue(value[1], this._sliderHandleFormatter);
                    }
                    if (this._forceUsingRange(this._config)) {
                        this._valueIndicator.html(value2);
                        this._$sliderAmountHandle.html(value2);
                    }
                    else {
                        this._valueIndicator.html("".concat(value1, " - ").concat(value2));
                        this._toolbox.$(this._$sliderAmountHandle[0]).html(value1);
                        this._toolbox.$(this._$sliderAmountHandle[1]).html(value2);
                    }
                }
                else {
                    if (this._sliderHandleFormatter) {
                        value = this._formatter.getFormattedValue(value, this._sliderHandleFormatter);
                    }
                    this._$sliderAmountHandle.html(value);
                }
            }
        }
        else {
            if (typeof value === 'object') {
                this._$sliderAmountHandle[0].html(value[0]);
                this._$sliderAmountHandle[1].html(value[1]);
            }
            else {
                this._$sliderAmountHandle.html(value);
            }
        }
    };
    /**
     * @desc method moves pips to noUi-base
     * @private
     */
    BSSSliderComponent.prototype._movePips = function () {
        logger.info('SliderComponent: ' +
            this._config.componentId +
            ' => function : _movePips');
        var pips = this._componentTemplate.find('.noUi-pips');
        this._$sliderBase.append(pips);
    };
    /**
     * @desc method generates new pips, removes old ones and add new
     * @private
     */
    BSSSliderComponent.prototype._reinitPips = function () {
        logger.info('SliderComponent: ' +
            this._config.componentId +
            ' => function : _reinitPips');
        if (!this._config.pips) {
            return;
        }
        var $pips = this._slider.pips(this._config.pips);
        var pips = this._componentTemplate.find('.noUi-pips');
        pips.remove();
        this._$sliderBase.append($pips);
        this._sliderSteps = this._componentTemplate.find('.noUi-marker');
        for (var i = 0, length_2 = this._sliderSteps.length; i < length_2; i++) {
            this._toolbox.$(this._sliderSteps[i]).text(this._sliderValues[i]);
        }
    };
    /**
     * @desc not used
     * @param {String} value
     * @param {String} unformattedValue
     * @private
     */
    BSSSliderComponent.prototype._updatePips = function (value, unformattedValue) {
        logger.info('SliderComponent: ' +
            this._config.componentId +
            ' => function : _updatePips' +
            ' | Params: ', value, unformattedValue);
        this._componentTemplate
            .find('.noUi-pips .noUi-marker')
            .removeClass('is-active is-covered');
        var self = this;
        this._toolbox._.find(this._componentTemplate.find('.noUi-pips .noUi-marker'), function (o) {
            if (Array.isArray(value) && value.length) {
                if (o.innerHTML === unformattedValue[0].toString() ||
                    o.innerHTML === unformattedValue[1].toString()) {
                    self._toolbox.$(o).addClass('is-active');
                }
                if (self._config.coveredPips) {
                    var arrayValue = parseFloat(o.innerHTML);
                    if (arrayValue > unformattedValue[0] &&
                        arrayValue < unformattedValue[1]) {
                        self._toolbox.$(o).addClass('is-covered');
                    }
                }
            }
            else {
                if (unformattedValue != undefined) {
                    if (o.innerHTML === unformattedValue.toString()) {
                        self._toolbox.$(o).addClass('is-active');
                        return;
                    }
                    if (self._config.coveredPips) {
                        var arrayValue = parseFloat(o.innerHTML);
                        if (arrayValue < unformattedValue.toString()) {
                            self._toolbox.$(o).addClass('is-covered');
                        }
                    }
                }
                else {
                    console.log(value);
                }
            }
        });
    };
    /**
     * @desc on start drag set {boolean} preventUpdateEvent to true - prevent trigger update function.
     * @private
     */
    BSSSliderComponent.prototype._preventUpdateEvent = function () {
        logger.info('SliderComponent: ' +
            this._config.componentId +
            ' => function : _preventUpdateEvent');
        this.preventUpdateEvent = true;
        this._$uiHandle = this._componentTemplate.find('.noUi-handle');
        if (this._$uiHandle.length > 1) {
            this._$uiHandle.removeClass('currently-touched');
            this._$uiHandle.filter('.noUi-active').addClass('currently-touched');
        }
    };
    /**
  
       /**
       * @desc _setValueFromSlider - sets value from slider to mobile(xs)
       * @param {Event} ev - calle event name
       * @private
       */
    BSSSliderComponent.prototype._setValueFromSlider = function (ev) {
        logger.info('SliderComponent: ' +
            this._config.componentId +
            ' => function : _setValueFromSlider | Params: ', ev);
        this._$uiHandle = this._componentTemplate.find('.noUi-handle');
        var value = this._slider.get();
        var curValue;
        if (typeof value === 'object') {
            curValue = [
                this._getNumberRepresentation(this._slider.get()[0]),
                this._getNumberRepresentation(this._slider.get()[1]),
            ];
        }
        else {
            if (this._forceUsingRange(this._config)) {
                curValue = [
                    this._config.range.min,
                    this._getNumberRepresentation(this._slider.get()),
                ];
            }
            else {
                curValue = this._getNumberRepresentation(this._slider.get());
            }
        }
        this._updatePips(value, curValue);
        this._isOnlyValueAdditionalChange = false;
        if (typeof curValue === 'object') {
            var marginalValuesLower = [
                curValue[0] === this._config.range.min,
                curValue[0] === this._config.range.max,
            ];
            var marginalValuesUpper = [
                curValue[1] === this._config.range.min,
                curValue[1] === this._config.range.max,
            ];
            if (marginalValuesLower[0] ||
                marginalValuesLower[1] ||
                marginalValuesUpper[0] ||
                marginalValuesUpper[1]) {
                if (this._forceUsingRange(this._config)) {
                    // Left side of slider is never movable
                    if (curValue[0] === this._config.range.min &&
                        curValue[1] === this._config.range.max) {
                        this._$uiHandle
                            .removeClass('noUi-handle-lower')
                            .addClass('noUi-handle-upper');
                        this._$uiHandle
                            .filter('.noUi-handle-upper')
                            .toggleClass('value-max', true);
                    }
                    else if (curValue[0] === this._config.range.min &&
                        curValue[1] === this._config.range.min) {
                        this._$uiHandle
                            .removeClass('noUi-handle-upper')
                            .addClass('noUi-handle-lower');
                        this._$uiHandle
                            .filter('.noUi-handle-lower')
                            .toggleClass('value-min', true);
                    }
                    else {
                        this._$uiHandle.removeClass('value-max value-min');
                    }
                }
                else {
                    this._$uiHandle
                        .filter('.noUi-handle-lower')
                        .toggleClass('value-min', marginalValuesLower[0])
                        .toggleClass('value-max', marginalValuesLower[1]);
                    this._$uiHandle
                        .filter('.noUi-handle-upper')
                        .toggleClass('value-min', marginalValuesUpper[0])
                        .toggleClass('value-max', marginalValuesUpper[1]);
                }
            }
            else {
                this._$uiHandle.removeClass('value-max value-min');
            }
            if (this._sliderHandleConfig) {
                this._updateAmountSliderHandle(curValue);
            }
        }
        else {
            if (curValue === this._config.range.min) {
                this._$uiHandle.addClass('value-min').removeClass('value-max');
            }
            else if (curValue === this._config.range.max) {
                this._$uiHandle.addClass('value-max').removeClass('value-min');
            }
            else {
                this._$uiHandle.removeClass('value-max').removeClass('value-min');
            }
            this._refreshIndicator(this._getFormattedRepresentation(curValue));
            if (this._sliderHandleConfig) {
                this._updateAmountSliderHandle(curValue);
            }
        }
        if (curValue === this._outputValueObj[this._outputValueName] ||
            JSON.stringify(curValue) ===
                JSON.stringify(this._outputValueObj[this._outputValueName])) {
            this._isCanceledTaggingEvent = true;
        }
        if (!this._config.variableAdditional && typeof value !== 'object') {
            this._setValueOnInput(value, curValue);
        }
        if (ev === 'end') {
            this.preventUpdateEvent = false;
        }
        if (ev === 'update' && this.preventUpdateEvent) {
            return;
        }
        if (ev !== 'init' &&
            this._isSliderInitialized === true &&
            (curValue !== this._outputValueObj[this._outputValueName] ||
                JSON.stringify(curValue) ===
                    JSON.stringify(this._outputValueObj[this._outputValueName]))) {
            this._onValueChange(curValue);
        }
    };
    /**
     * @desc method updates value on inputa after change on slider and update custom placeholder value
     * @param {String} value
     * @param {String} unformattedValue
     * @private
     */
    BSSSliderComponent.prototype._setValueOnInput = function (value, unformattedValue) {
        logger.info('SliderComponent: ' +
            this._config.componentId +
            ' => function : _setValueOnInput | Params: ', value, unformattedValue);
        if (!this._textInput) {
            return;
        }
        var closestVal = this._getClosestNumber(unformattedValue, this._sliderValues);
        // this._numberInput.val(unformattedValue);
        this._numberInput.val(closestVal);
        this._textInput.val(this._getFormattedRepresentation(closestVal));
    };
    BSSSliderComponent.prototype._setValueOnInputVariableAdditional = function (value) {
        if (value === void 0) { value = null; }
        logger.info('SliderComponent: ' +
            this._config.componentId +
            ' => function : _setValueOnInputAmount');
        if (!this._textInput) {
            return;
        }
        var currentValue;
        if (value === null) {
            currentValue = this._formatter.getFormattedValue(this._config.startValueAdditional, this._formatterAdditional);
        }
        else {
            currentValue = this._formatter.getFormattedValue(value, this._formatterAdditional);
        }
        currentValue = this._checkValueAdditional(currentValue);
        this._numberInput.val(currentValue);
        this._textInput.val(currentValue);
    };
    /**
     * @desc _initSliderBtns - initialize all btn and subscribe listeners
     * @listens {bss-start-resize-for-$ENTITY-INSTANCE-ID}
     * @listens {bss-stop-resize-for-$ENTITY-INSTANCE-ID}
     * @private
     */
    BSSSliderComponent.prototype._initSliderBtns = function () {
        logger.info('SliderComponent: ' +
            this._config.componentId +
            ' => function : _initSliderBtns');
        if (this._isSliderDisabled && this._config.disabled) {
            return;
        }
        this._componentTemplate
            .find('#' + this._config.componentId + '_plus')
            .on('click.' + this._config.componentId, this._setNextValue.bind(this));
        this._componentTemplate
            .find('#' + this._config.componentId + '_minus')
            .on('click.' + this._config.componentId, this._setPrevValue.bind(this));
        if (this._config.componentTemplate === 'incrementerTemplate') {
            this._toggleIncrementer();
        }
        if (this._config.popupInputResolutions &&
            this._inputPopup &&
            this._inputPopup.length > 0) {
            this._setPopupBtns();
            this._isResizeEventOff = true;
            this._bindResize();
            this._eventManager.subscribe('bss-start-resize-for-' + this._config.entityInstanceId, this._bindResize.bind(this), this.subscriberPrefix + this._config.componentId);
            this._eventManager.subscribe('bss-stop-resize-for-' + this._config.entityInstanceId, this._unbindResize.bind(this), this.subscriberPrefix + this._config.componentId);
        }
    };
    /**
     * @desc bind window scroll event
     * @listens {bss-device-type-changed}
     * @private
     */
    BSSSliderComponent.prototype._bindResize = function () {
        logger.info('SliderComponent: ' +
            this._config.componentId +
            ' => function : _bindResize');
        if (this._isResizeEventOff) {
            this._eventManager.subscribe('bss-device-type-changed', this._checkPopupState.bind(this), this.subscriberPrefix + this._config.componentId);
            this._isResizeEventOff = false;
        }
    };
    /**
     * @desc unbind window scroll event
     * @private
     */
    BSSSliderComponent.prototype._unbindResize = function () {
        logger.info('SliderComponent: ' +
            this._config.componentId +
            ' => function : _unbindResize');
        this._eventManager.unsubscribe('bss-device-type-changed', this._checkPopupState.bind(this), this.subscriberPrefix + this._config.componentId);
        this._isResizeEventOff = true;
    };
    /**
     * @desc _setPopupBtns - initialize popup btn, hide popup if are visible
     * @private
     */
    BSSSliderComponent.prototype._setPopupBtns = function () {
        logger.info('SliderComponent: ' +
            this._config.componentId +
            ' => function : _setPopupBtns');
        this._componentTemplate
            .find('#' + this._config.componentId + '_input')
            .on('click.' + this._config.componentId, this._showPopup.bind(this));
        this._componentTemplate
            .find('#' + this._config.componentId + '_indicator')
            .on('click.' + this._config.componentId, this._showPopup.bind(this));
        this._inputPopup
            .find('#' + this._config.componentId + '_close-btn')
            .on('click.' + this._config.componentId, this._closePopup.bind(this));
    };
    /**
     * @desc _checkPopupState - check popup if are visible on not compatible view hide it.
     * @private
     */
    BSSSliderComponent.prototype._checkPopupState = function () {
        logger.info('SliderComponent: ' +
            this._config.componentId +
            ' => function : _checkPopupState');
        if (this._inputPopup.is(':visible') &&
            !this._resolution
                ._getDeviceType()
                .match(new RegExp(this._config.popupInputResolutions, 'i'))) {
            this._inputPopup.fadeOut();
        }
    };
    /**
     * @desc _showPopup - shows mobile popup
     * @private
     */
    BSSSliderComponent.prototype._showPopup = function () {
        logger.info('SliderComponent: ' +
            this._config.componentId +
            ' => function : _showPopup');
        if (this._resolution
            ._getDeviceType()
            .match(new RegExp(this._config.popupInputResolutions, 'i'))) {
            this._inputPopup.fadeIn();
            this._inputPopup
                .find('#' + this._config.componentId + '_popup-input')
                .focus();
        }
    };
    /**
     * @desc method triggered on keypress, simulates submit form behavior after press eneter, changes are procceded with on change
     * @param {Event} ev - calle event name
     * @private
     */
    BSSSliderComponent.prototype._onEnter = function (ev) {
        logger.info('SliderComponent: ' +
            this._config.componentId +
            ' => function : _onEnter | Params: ', ev);
        var keyCode = 'which' in ev ? ev.which : ev.keyCode;
        var $elm;
        if (keyCode === 13) {
            $elm = this._toolbox.$(ev.currentTarget);
            $elm.trigger('blur');
            // $elm.focus();
        }
    };
    /**
     * @desc method triggered on keydown - remove the possibility of entering characters that are not of a number, comma and enter
     * @param {Event} ev - calle event name
     * @private
     */
    BSSSliderComponent.prototype._onCharactersEnter = function (ev) {
        logger.info('SliderComponent: ' +
            this._config.componentId +
            ' => function : _onCharactersEnter | Params: ', ev);
        var keyCode = 'which' in ev ? ev.which : ev.keyCode;
        var mark = this._formatter.formatters[this._config.formatter + 'Settings'].mark;
        var markCode;
        switch (mark) {
            case '.':
                markCode = 190;
                break;
            default:
                markCode = 188;
        }
        //french keyboard
        var isNumberWithShiftOnNumberKey = ev.shiftKey &&
            keyCode >= 48 &&
            keyCode <= 57 &&
            Number.isInteger(parseInt(ev.key));
        var isNotNumberOnNumberKey = keyCode >= 48 && keyCode <= 57 && !Number.isInteger(parseInt(ev.key));
        if (((keyCode !== markCode &&
            keyCode !== 8 &&
            keyCode !== 144 &&
            keyCode !== 13 &&
            (keyCode < 96 || keyCode > 105) &&
            (keyCode < 48 || keyCode > 57)) ||
            ev.shiftKey ||
            isNotNumberOnNumberKey) &&
            isNumberWithShiftOnNumberKey === false) {
            ev.preventDefault();
        }
        //document.activeElement.scrollIntoViewIfNeeded();
    };
    /**
     * @desc _showPopup - close mobile popup
     * @private
     */
    BSSSliderComponent.prototype._closePopup = function () {
        logger.info('SliderComponent: ' +
            this._config.componentId +
            ' => function : _closePopup');
        this._inputPopup.fadeOut();
    };
    /**
     * @desc  _getStepNumber - get Step number.
     * @param {String} curValue
     * @param {Number} indexOffset
     * @private
     */
    BSSSliderComponent.prototype._getStepNumber = function (curValue, indexOffset) {
        logger.info('SliderComponent: ' +
            this._config.componentId +
            ' => function : _getStepNumber' +
            ' | Params: ', curValue, indexOffset);
        return this._sliderValues[this._sliderValues.indexOf(curValue) + indexOffset];
    };
    /**
     * @desc indexOffset_generateCustomSliderConfig - calculate slider config based on data from BSSConnector
     * @param {Object} config - configuration data from BSSConnector
     * @return {Object} calculated slider config
     * @private
     */
    BSSSliderComponent.prototype._generateCustomSliderConfig = function (config) {
        var _a;
        logger.info('SliderComponent: ' +
            this._config.componentId +
            ' => function : _generateCustomSliderConfig' +
            ' | Params: ', config);
        var tempConfig = config;
        var startObj = {};
        if ((_a = this._config.sliderHandle) === null || _a === void 0 ? void 0 : _a.sliderStartingValue) {
            startObj.value = this._config.sliderHandle.sliderStartingValue;
        }
        else {
            startObj = this._getValueObject(config.variable);
        }
        var startObjAdditional;
        // first set some defaults in slider configuration
        tempConfig.popupInputResolutions =
            'popupInputResolutions' in config ? config.popupInputResolutions : 'xs';
        tempConfig.inputMaxLength = config.inputMaxLength
            ? config.inputMaxLength
            : 20;
        tempConfig.sliderHandleDecimalPlaces = config.sliderHandleDecimalPlaces
            ? config.sliderHandleDecimalPlaces
            : 2;
        tempConfig.animate = !!config.animate;
        tempConfig.connect = config.connect ? config.connect : false;
        tempConfig.boundaryValuesToFixed = config.boundaryValuesToFixed
            ? !!config.boundaryValuesToFixed
            : false;
        tempConfig.selectInput = config.selectInput ? config.selectInput : true; //select text on input text on focus
        tempConfig.pips = config.pips
            ? {
                stepped: config.pips.stepped ? config.pips.stepped : true,
                density: config.pips.density ? config.pips.density : 100,
                mode: config.pips.mode ? config.pips.mode : 'steps',
                filter: config.pips.filter ? config.pips.filter : filter,
            }
            : {
                stepped: true,
                density: 100,
                mode: 'steps',
                filter: filter,
            };
        if (config.notDisabledPips) {
            tempConfig.pips = false;
        }
        if (config.variableAdditional) {
            startObjAdditional = this._getValueObject(config.variableAdditional);
            this._formatterAdditional = startObjAdditional.formatter;
            this._outputValueAdditional = startObjAdditional.value;
            tempConfig.startValueAdditional = parseFloat(this._getValue(config.variableAdditional));
        }
        tempConfig.range = {};
        tempConfig.start = null;
        this._outputValueName = startObj.value;
        if (typeof this._formatter.formatters[startObj.formatter] !== 'undefined') {
            tempConfig.format = this._formatter.formatters[startObj.formatter];
            tempConfig.formatter = startObj.formatter;
        }
        if (typeof this._getValue(config.variable) === 'object') {
            if (this._forceUsingRange(config)) {
                tempConfig.start = parseFloat(this._getValue(config.variable)[1]);
            }
            else {
                tempConfig.start = [
                    parseFloat(this._getValue(config.variable)[0]),
                    parseFloat(this._getValue(config.variable)[1]),
                ];
            }
        }
        else {
            tempConfig.start = parseFloat(this._getValue(config.variable));
        }
        if (typeof config.variableList !== 'undefined' &&
            config.variableList !== '' &&
            this._getValue(config.variableList) !== '' &&
            typeof this._getValue(config.variableList) !== 'undefined') {
            tempConfig.range = this._generateSliderRangeFromList.bind(this, this._getValue(config.variableList))();
            this._isListUsed = true;
            tempConfig.snap = true;
            return tempConfig;
        }
        if (config.isBaseWithPadding) {
            if ('baseMin' in config && 'baseMax' in config) {
                tempConfig.limitLeft = parseFloat(this._getValue(config.variableMin));
                tempConfig.limitRight = parseFloat(this._getValue(config.variableMax));
                tempConfig.range.min = parseFloat(this._getValue(config.baseMin));
                tempConfig.range.max = parseFloat(this._getValue(config.baseMax));
            }
            else {
                //we assume that is percentage slider with range from 0 to 100
                tempConfig.limitLeft = parseInt(this._getValue(config.variableMin), 10);
                tempConfig.limitRight = parseInt(this._getValue(config.variableMax), 10);
                tempConfig.range.min = 0;
                tempConfig.range.max = 100;
            }
            tempConfig.padding = [];
            tempConfig.padding[0] = tempConfig.limitLeft - tempConfig.range.min;
            tempConfig.padding[1] = tempConfig.range.max - tempConfig.limitRight;
        }
        else {
            tempConfig.range.max = parseFloat(this._getValue(config.variableMax));
            tempConfig.range.min = parseFloat(this._getValue(config.variableMin));
        }
        if (this._getValue(config.slideSeats)) {
            var _b = tempConfig.range, min = _b.min, max = _b.max;
            min = min < 1 ? 1 : min;
            tempConfig.minSeats = min;
            tempConfig.maxSeats = max;
            tempConfig.range.min = min;
        }
        tempConfig.step = parseFloat(this._getValue(config.variableStep));
        if (tempConfig.step % 1 === 0) {
            if (Array.isArray(tempConfig.start)) {
                if (tempConfig.boundaryValuesToFixed) {
                    tempConfig.start[0] =
                        tempConfig.start[0] === tempConfig.range.min
                            ? Math.floor(tempConfig.start[0])
                            : Math.round(tempConfig.start[0]);
                    tempConfig.start[1] =
                        tempConfig.start[1] === tempConfig.range.max
                            ? Math.ceil(tempConfig.start[1])
                            : Math.round(tempConfig.start[1]);
                }
                else {
                    for (var i = 0; i < tempConfig.start.length; i++) {
                        tempConfig.start[i] = Math.round(tempConfig.start[i]);
                    }
                }
            }
        }
        if (tempConfig.boundaryValuesToFixed) {
            tempConfig.range.min = Math.floor(this._config.range.min);
            tempConfig.range.max = Math.ceil(this._config.range.max);
        }
        try {
            if (isNaN(tempConfig.range.max) ||
                isNaN(tempConfig.range.min) ||
                isNaN(tempConfig.step)) {
                this.setErrorObject({
                    errorMsg: 'config -> there is no complete set of data',
                    errorSeverity: 'critical',
                });
            }
        }
        catch (errorMsg) {
            this.setErrorObject({
                errorMsg: errorMsg,
                errorSeverity: 'critical',
            });
            this.isNotRendered = true;
        }
        for (var i = 0, length_3 = parseInt((tempConfig.range.max - tempConfig.range.min) / tempConfig.step); i <= length_3; i++) {
            this._sliderValues[i] = tempConfig.range.min + i * tempConfig.step;
        }
        //we want to be possible to set max even though it is out of range
        if ((tempConfig.range.max - tempConfig.range.min) % tempConfig.step !== 0) {
            this._sliderValues.push(tempConfig.range.max);
        }
        this._isListUsed = false;
        return tempConfig;
    };
    /**
     * @desc indexOffset _generateCustomSliderConfig - calculate slider range object base on range {String} from BSSConnector
     * @param {String} configList -range List from BSSConnector
     * @return {Object} calculated slider range object
     * @private
     */
    BSSSliderComponent.prototype._generateSliderRangeFromList = function (configList) {
        logger.info('SliderComponent: ' +
            this._config.componentId +
            ' => function : _generateSliderRangeFromList' +
            ' | Params: ', configList);
        try {
            if (!helper.validateRegExp('^-?[0-9]+([.][0-9]+)?((;-?[0-9]+)([.][0-9]+)?)*$', configList)) {
                this.setErrorObject({
                    errorMsg: "config -> variableList or linked value doesn't match proper format",
                    errorSeverity: 'critical',
                });
            }
        }
        catch (errorMsg) {
            this.setErrorObject({
                errorMsg: errorMsg,
                errorSeverity: 'critical',
            });
            this.isNotRendered = true;
        }
        var range = {};
        var rangeLength;
        var configArray = configList.split(';');
        if (configArray.length === 1) {
            range.min = parseFloat(configList);
            range.max = parseFloat(configList);
            return range;
        }
        else {
            configArray = helper.sortAsFloats(configArray);
            if (!this._isSliderListCorrect(configArray)) {
                this.isNotRendered = true;
                this.setErrorObject({
                    errorMsg: 'config -> variableList is incorrect',
                    errorSeverity: 'critical',
                });
            }
        }
        range.min = configArray[0]; //, configArray[1] - configArray[0]];
        range.max = this._sliderValues[configArray.length - 1] =
            configArray[configArray.length - 1];
        rangeLength = range.max - range.min;
        this._sliderValues[0] = range.min;
        this._sliderValues[configArray.length - 1] = range.max;
        for (var i = 1, length_4 = configArray.length - 1; i < length_4; i++) {
            var percent = ((configArray[i] - range.min) * 100) / rangeLength;
            range[percent + '%'] = configArray[i];
            this._sliderValues[i] = configArray[i];
        }
        return range;
    };
    /**
     * @desc destroys infohint and call super method
     * @public
     * @override
     */
    BSSSliderComponent.prototype.destroy = function () {
        logger.info('SliderComponent: ' + this._config.componentId + ' => function : destroy');
        if (this.isDestroyed) {
            return;
        }
        if (typeof this._infohint !== 'undefined') {
            this._infohint.destroy();
        }
        this._isSliderInitialized = false;
        _super.prototype.destroy.call(this);
    };
    /**
     * @desc initialize tagging - for slider should be empty and done after slider is created
     * @private
     * @override
     */
    BSSSliderComponent.prototype._initializeTagging = function () { };
    /**
     * @desc actual _initializeTagging just called after this._slider is created
     * @private
     */
    BSSSliderComponent.prototype._initializeTaggingSlider = function () {
        logger.info('SliderComponent: ' +
            this._config.componentId +
            ' => function : _initializeTaggingSlider');
        if (!this._config.tagEvent) {
            logger.info('SliderComponent: ' +
                this._config.componentId +
                ' => function : _initializeTagging' +
                ' | NO TAGGING');
            return;
        }
        for (var i = 0, len = this._config.tagEvent.length; i < len; i++) {
            if (this._config.tagEvent[i].onEvent === 'update') {
                this._slider.on('update', this._onTaggingEvent.bind(this, this._config.tagEvent[i].throwEvent, this._config.tagEvent[i].throwAfterCalculation));
                this._slider.on('end', this._onTaggingEvent.bind(this, this._config.tagEvent[i].throwEvent, this._config.tagEvent[i].throwAfterCalculation));
            }
            else {
                this._componentTemplate
                    .find(this._config.tagEvent[i].selector)
                    .on(this._config.tagEvent[i].onEvent + '.' + this._config.componentId, this._onTaggingEvent.bind(this, this._config.tagEvent[i].throwEvent, this._config.tagEvent[i].throwAfterCalculation));
            }
        }
    };
    /**
     * @desc initialize slider handle
     * @private
     */
    BSSSliderComponent.prototype._initializeSliderHandle = function () {
        logger.info('SliderComponent: ' +
            this._config.componentId +
            ' => function : _initializeSliderHandle');
        this._sliderHandleConfig = this._config.sliderHandle || false;
        if (this._sliderHandleConfig) {
            this._$sliderHandle = this._toolbox
                .$(this._slider.target)
                .find('.noUi-handle');
            this._$sliderAmountHandle = this._$sliderHandle.find('.bss-slider_amount-handle_inner');
            this.sliderHandlePriceCar = this._config.sliderHandle.priceCar;
            this._priceCar = parseFloat(this._getValue(this.sliderHandlePriceCar));
            if (this.sliderHandlePriceCar) {
                this._sliderHandleDecimalPlaces =
                    this._config.sliderHandle.sliderHandleDecimalPlaces;
            }
            else {
                this._sliderHandleFormatter =
                    this._config.sliderHandle.sliderHandleFormatter;
            }
        }
    };
    /**
     * @desc initialize additional events
     * @private
     */
    BSSSliderComponent.prototype._initializeSliderSeats = function () {
        logger.info('SliderComponent: ' +
            this._config.componentId +
            ' => function : _initializeSliderSeats');
        if (this._config.slideSeats) {
            var sliderSeats = this._toolbox.$('#' + this._config.componentId);
            sliderSeats.addClass('bss-slider--seats bss-slider-seats--add');
        }
    };
    /**
     * @desc on tagging event
     * @param {String} throwEvent event which is key for tagging settings in TFSDriver
     * @param {Boolean} throwAfterCalculation - true when component triggers recalculation (like slider, inputs)
     * @param {Event} event
     * @protected
     * @override
     */
    BSSSliderComponent.prototype._onTaggingEvent = function (throwEvent, throwAfterCalculation, event) {
        logger.info('SliderComponent: ' +
            this._config.componentId +
            ' => function : _onTaggingEvent' +
            ' | Params: ', throwEvent, throwAfterCalculation, event);
        //first if is only for tagging currency + percentage slider (with variableAdditional)
        if (this._isSliderInitialized &&
            !this._isCanceledTaggingEvent &&
            typeof this._outputValueObj === 'object' &&
            this._outputValueObj.triggerName &&
            this._outputValueAdditional &&
            this._outputValueObj.triggerName === this._outputValueAdditional) {
            _super.prototype._onTaggingEvent.call(this, throwEvent, throwAfterCalculation);
        }
        else {
            if (this.preventUpdateEvent ||
                !this._isSliderInitialized ||
                this._isCanceledTaggingEvent) {
                this._isCanceledTaggingEvent = false;
                return;
            }
            _super.prototype._onTaggingEvent.call(this, throwEvent, throwAfterCalculation);
        }
    };
    /**
     * @desc Check if force using is enable. When it is enable 'variable' from config is treated as a table of values not single value
     * @param {Object} config - configuration for component
     * @private
     */
    BSSSliderComponent.prototype._forceUsingRange = function (config) {
        logger.info('SliderComponent: ' +
            this._config.componentId +
            ' => function : _forceUsingRange | Params: ', config);
        return config.forceUsingRange;
    };
    return BSSSliderComponent;
}(BSSAbstractComponent));
export default BSSSliderComponent;
